import React from 'react';
import type { AuthMethod } from '../types';

type Props = {
  nextStep: (authMethod: AuthMethod) => void;
};

export function AuthMethodStep({ nextStep }: Props) {
  return (
    <div className="row justify-content-center">
      <div className="col-8">
        <div className="card box-shadow-3d mb-3">
          <div className="card-header">
            <div className="d-flex align-items-center">
              <img
                className="con-map-mk-integration-logo-size"
                style={{ width: '30px' }}
                src="/media/integrations/logos/bigquery-icon.png"
              />
              <h5 className="mb-0 ml-3">
                BigQuery — Choose authentication method
              </h5>
            </div>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <div className="card h-100">
                  <div className="card-body d-flex flex-column">
                    <h5 className="card-title">OAuth</h5>
                    <p className="card-text flex-grow-1">
                      Sign in with a Google account. Requires re-authentication
                      when your organization's Google Cloud session policy
                      expires.
                    </p>
                    <button
                      className="btn btn-outline-primary mt-3"
                      onClick={() => nextStep('oauth')}
                    >
                      Use OAuth
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card h-100">
                  <div className="card-body d-flex flex-column">
                    <h5 className="card-title">Service Account</h5>
                    <p className="card-text flex-grow-1">
                      Use a Google Cloud service account JSON key. Does not
                      expire — recommended for production integrations.
                    </p>
                    <button
                      className="btn btn-outline-primary mt-3"
                      onClick={() => nextStep('service_account')}
                    >
                      Use Service Account
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
